import AppDialog from './Dialog.vue';
import AppDialogBody from './DialogBody.vue';
import AppDialogDescription from './DialogDescription.vue';
import AppDialogFooter from './DialogFooter.vue';
import AppDialogHeader from './DialogHeader.vue';
import AppDialogTitle from './DialogTitle.vue';

export default { AppDialog, AppDialogBody, AppDialogTitle, AppDialogDescription, AppDialogHeader, AppDialogFooter };
